export const IS_PRODUCTION_OPERATION = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
export const IMAGE_SERVER = 'https://images.therich.io'
